module.exports = __webpack_public_path__ + "img/neglected-unactive.c85f29f.svg";